<template>
  <div class="content-heading">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">{{ title }}</div>
        <div class="col-md-6 text-right" v-if="!is_supplier">
          <router-link :to="{name: url}" :title="title" class="btn btn-sm btn-warning">
            <i class="icon-plus"></i> {{ button }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    url: String,
    button: String
  },
  data () {
    return {
    }
  },
  computed: {
    is_supplier () {
      return this.$store.getters.user_group === 'Supplier'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contentheading.vue